<template>
  <!--
    OS BILHETES DE AVISO (D0, 03/09): a confirmação de "aconteceu" — compra feita, moedas
    recebidas — num bilhete de papel que sobe da barra e vai embora sozinho. Não é modal de
    propósito: a compra JÁ foi confirmada num modal; exigir outro clique de "OK" seria cobrar
    o jogador duas vezes pela mesma decisão. Clicar no bilhete o dispensa antes da hora.
  -->
  <Teleport to="body">
    <TransitionGroup
      v-if="fila.length"
      name="aviso"
      tag="div"
      class="fish-avisos"
      aria-live="polite"
      role="status"
    >
      <button
        v-for="aviso in fila"
        :key="aviso.id"
        type="button"
        class="fish-avisos__bilhete"
        :class="{ 'fish-avisos__bilhete--ruim': aviso.tom === 'ruim' }"
        @click="dispensar(aviso.id)"
      >
        <FishIcon v-if="aviso.icone" :nome="aviso.icone" tamanho="pequeno" />
        <span>{{ texto(aviso) }}</span>
      </button>
    </TransitionGroup>
  </Teleport>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getTranslation } from '@/i18n/utils/translations';
import FishIcon from './FishIcon.vue';

export default {
  name: 'FishAviso',
  components: { FishIcon },
  computed: {
    ...mapState('avisos', ['fila']),
  },
  methods: {
    ...mapActions('avisos', ['dispensar']),
    texto(aviso) {
      // A frase pronta do servidor não passa pelo i18n: `$t` de um texto que não
      // é chave devolve o próprio texto, mas com o aviso de chave faltando no
      // console a cada erro do jogo.
      if (!aviso.chave) return aviso.texto || '';

      const parametros = { ...aviso.parametros };
      // Nome de item vem cru do catálogo (pt); nas outras línguas passa pela tabela de itens —
      // a mesma decisão do modal de confirmação de compra.
      if (parametros.name && this.$i18n.locale !== 'pt') {
        parametros.name = getTranslation(parametros.name, this.$i18n.locale, 'name') || parametros.name;
      }
      return this.$t(aviso.chave, parametros);
    },
  },
};
</script>

<style scoped>
.fish-avisos {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(var(--altura-barra, 104px) + var(--e-2));
  z-index: 600; /* acima de --z-modal (500): o aviso confirma o que o modal acabou de fazer */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--e-1);
  pointer-events: none;
  width: min(420px, calc(100vw - 2 * var(--e-3)));
}

.fish-avisos__bilhete {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: var(--e-2);
  max-width: 100%;
  border: none;
  border-left: 4px solid var(--latao);
  background: var(--papel);
  color: var(--tinta);
  font-family: var(--fonte-corpo);
  font-size: var(--f-2);
  text-align: left;
  padding: var(--e-2) var(--e-3);
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.35);
  cursor: pointer;
}

/* O que NÃO deu certo troca o latão pelo vermelho da tinta ruim, e só isso: o
 * bilhete continua sendo papel, porque o material não muda com a notícia. */
.fish-avisos__bilhete--ruim {
  border-left-color: var(--ruim, #a33);
}

.aviso-enter-active {
  transition: transform var(--t-medio) var(--curva-quique), opacity var(--t-medio) var(--curva-suave);
}

.aviso-leave-active {
  transition: transform var(--t-medio) var(--curva-suave), opacity var(--t-medio) var(--curva-suave);
}

.aviso-enter-from {
  transform: translateY(12px);
  opacity: 0;
}

.aviso-leave-to {
  transform: translateY(6px);
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .aviso-enter-active,
  .aviso-leave-active {
    transition: opacity var(--t-curto) linear;
  }

  .aviso-enter-from,
  .aviso-leave-to {
    transform: none;
  }
}
</style>
